import { render, staticRenderFns } from "./NotificationsFilters.vue?vue&type=template&id=19711e30&scoped=true&"
import script from "./NotificationsFilters.vue?vue&type=script&lang=js&"
export * from "./NotificationsFilters.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsFilters.vue?vue&type=style&index=0&id=19711e30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19711e30",
  null
  
)

export default component.exports